/*
 * Feature Flags
 * =============
 *
 * Each constant should be assigned to a string that
 * represents a feature flag listed in:
 *
 *   noun_project/settings/base.py > `FLAGS`
 *
 * Please remove flags that are no longer in use.
 */

export const PHOTO_UPLOAD_FLAG = "PHOTO_UPLOAD";
export const PHOTO_DASHBOARD_FLAG = "PHOTO_DASHBOARD";
export const PHOTO_ROYALTIES_FLAG = "PHOTO_ROYALTIES";
export const PHOTO_SUBMISSIONS_FLAG = "PHOTO_SUBMISSIONS";
